import { withDatasourceCheck } from "@sitecore-jss/sitecore-jss-nextjs";
import { ComponentProps } from "lib/component-props";
import Image from "next/image";
import { useEffect, useState } from "react";
type ApproachProps = ComponentProps & {
  fields: any;
  locale: any;
};
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper";

gsap.registerPlugin(ScrollTrigger);
const Approach = (props: ApproachProps): JSX.Element => {
  const [isCardHovered, setIsCardHovered] = useState(true)
  const [mounted, setMounted] = useState(false)

  const isMobile = useMediaQuery({
    query: "(min-width: 768px)"
  })
  useEffect(() => {
    setMounted(true)
    gsap.set(".animate-top", {
      opacity: 0,
      y: 100,
    });
    ScrollTrigger.batch(".animate-top", {
      onEnter: (batch) =>
        gsap.to(batch, {
          opacity: 1,
          y: 0,
          stagger: { each: 0.4 },
          overwrite: true,
        }),
      onEnterBack: (batch) =>
        gsap.to(batch, { opacity: 1, y: 0, stagger: 0.4, overwrite: true }),
    });
  }, []);
  if(!mounted){
    return<></>;
  }
  return (
    <div id="approach" className="responsive overflow-hidden">
      <div
        className={`lg:mb-24 mb-14  ${
          props?.locale == "ar" ? "rtl" : ""
        }`}
      >
        <div className="grid xl:grid-cols-2 grid-cols-1">
          <div className="col-span-1">
            <h2 className="xl:text-[28px] text-[22px] font-bold text-[#0F2837] text-justify ">
              {props?.fields?.title?.value}
            </h2>
            <p className="text-[#5E5E5E] font-normal lg:py-8 py-3 text-sm md:text-base xl:text-lg text-justify">
              {" "}
              {props?.fields?.description?.value}
            </p>
          </div>
        </div>

        {isMobile && <div className="grid xl:grid-cols-4 lg:grid-cols-2 grid-cols-1 gap-5 ">
          {props?.fields?.childItems?.map((approach: any, index: number) => {
            return (
              <div className="group animate-top approach-items-wrp" onClick={()=>{
                if(isMobile){
                  return
                }
                const listItems = [...document.querySelectorAll(".approach-items-wrp")]
                listItems.map((item: any, innerIndex: number)=>{
                  if(item.classList.contains("approach-items") && innerIndex != index){
                    item?.classList.remove("approach-items")
                  }
                })

                if(listItems[index].classList.contains("approach-items")){
                  listItems[index]?.classList.remove("approach-items")
                }else{
                  listItems[index]?.classList.add("approach-items")
                }
              }}>
                <div
                  key={index}
                  className={`approach-item col-span-1 cursor-pointer  h-fit bg-[#F2F2F2] py-4  overflow-visible
                   ${index == 0 ? (isCardHovered ? "md:!bg-[#0F2837]":"md:group-hover:bg-[#0F2837]"):"md:group-hover:bg-[#0F2837]"}`}
                  onMouseEnter={()=>{if(!isCardHovered) return; setIsCardHovered(false)}}
                  // onMouseLeave={()=>{if(!isCardHovered) return; setIsCardHovered(false)}}
                >
                  <div className="px-5 flex gap-4 items-center">
                    <div className={`lightIcon flex
                    ${index == 0 ? (isCardHovered ? "md:!hidden":"md:group-hover:hidden"):"md:group-hover:hidden"}`}>
                      <Image
                        src={approach?.fields?.LightIcon?.value.src}
                        width={approach?.fields?.LightIcon?.value.width}
                        height={approach?.fields?.LightIcon?.value.height}
                        alt={approach?.fields?.LightIcon?.value?.alt || approach?.fields?.Title?.value || "Approach icon"}
                      ></Image>
                    </div>
                    <div className={`darkIcon md:group-hover:flex hidden
                    ${index == 0 ? (isCardHovered ? "md:!flex":"md:group-hover:flex"):"md:group-hover:flex"}`}>
                      <Image
                        src={approach?.fields?.DarkIcon?.value.src}
                        width={approach?.fields?.DarkIcon?.value.width}
                        height={approach?.fields?.DarkIcon?.value.height}
                        alt={approach?.fields?.DarkIcon?.value?.alt || approach?.fields?.Title?.value || "Approach icon"}
                      ></Image>
                    </div>

                    <p className={`title text-[#0F2837] md:group-hover:text-white font-medium text-[18px] text-justify
                    ${index == 0 ? (isCardHovered ? "md:!text-white":"md:group-hover:text-white"):"md:group-hover:text-white"}`}>
                      {approach?.fields?.Title?.value}
                    </p>
                  </div>
                </div>
                <div className={`description !pt-0 md:group-hover:text-white px-5 w-full bg-[#0F2837] text-justify
                md:group-hover:py-7 h-0 md:group-hover:h-fit duration-300 overflow-hidden text-sm lg:text-base
                ${index == 0 ? (isCardHovered ? "md:!text-white md:py-7 md:!h-fit":
                "md:group-hover:text-white md:group-hover:py-7 md:group-hover:h-fit")
                :"md:group-hover:text-white md:group-hover:py-7 md:group-hover:h-fit"}`}>
                  <div className="pb-3">
                      <svg
                        width="52"
                        height="6"
                        viewBox="0 0 52 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden={true}
                        focusable="false"
                      >
                        <rect width="52" height="6" fill="#FF9619" />
                      </svg>
                  </div>
                  {approach?.fields?.Description?.value}
                </div>
              </div>
            );
          })}
        </div>}
        {!isMobile && <div>
          <Swiper
          slidesPerView={1.3}
          freeMode={true}
          spaceBetween={10}
          resistanceRatio={0}
          modules={[FreeMode]}
          className="h-full min-h-full cursor-grab"
          >
            {props?.fields?.childItems?.map((approach: any, index: number) => {
              return(
                <SwiperSlide key={index} className="bg-[#F2F2F2] flex flex-col p-4 !h-auto !justify-start">
                  <div className="darkIcon md:group-hover:flex mb-2 flex justify-center items-center">
                    <Image
                      src={approach?.fields?.MobileIcon?.value.src}
                      width={"30px"}
                      height={"30px"}
                      alt={approach?.fields?.MobileIcon?.value?.alt || approach?.fields?.Title?.value || "Approach icon"}
                    ></Image>
                  </div>
                  <div>
                    <h4 className="title text-[#0F2837] md:group-hover:text-white font-medium text-[18px]">
                      {approach?.fields?.Title?.value}
                    </h4>
                    <div className="pb-3">
                      <svg
                        width="52"
                        height="6"
                        viewBox="0 0 52 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden={true}
                        focusable="false"
                      >
                        <rect width="52" height="6" fill="#FF9619" />
                      </svg>
                    </div>
                  </div>
                  <div className="text-start w-full duration-300 overflow-hidden text-sm lg:text-base">

                  {approach?.fields?.Description?.value}
                </div>
                </SwiperSlide>
              )
            })}
          </Swiper>
        </div>}
      </div>
    </div>
  );
};

export default withDatasourceCheck()<ApproachProps>(Approach);
